import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import template from './dynamicCriteriaView.html';
import Logger from '../logger';
import searchItemsPriority, { preferredPrioritySupportCriterias } from '../../constants/searchItemsPriority';

export class DynamicCriteriaComponent {
    /* @ngInject */
    constructor(dynamicDataService, staticDataService, $timeout, RouteService, searchCacheService, utils, $element, $scope) {
        this.utils = utils;
        this.$scope = $scope;
        this.staticDataService = staticDataService;
        this.$scope.searchItemsPriority = searchItemsPriority;
        this.$scope.preferredPrioritySupportCriterias = preferredPrioritySupportCriterias;
        this.searchCacheService = searchCacheService;
        const ctrl = this;
        ctrl.init = function () {
            ctrl.filteredValuesCount = RouteService.getSystemPreference('filteredValuesCount');
            ctrl.filteredValuesDynamicDelay = RouteService.getSystemPreference('filteredValuesDynamicDelay');
            ctrl.mandatoryValues = [
                {
                    value: 'optional',
                    text: 'NORMAL',
                },
                {
                    value: 'preferred',
                    text: 'PREFERRED_PRIORITY_LABEL',
                },
                {
                    value: 'mandatory',
                    text: 'MANDATORY_MINUS',
                },
                {
                    value: 'filter',
                    text: 'MANDATORY',
                },
            ];
        };

        ctrl.modifyValue = function (data) {
            ctrl.showAdd = true;
            ctrl.filterValues = data.text || data.value;

            if (data.additional) {
                ctrl.subCriteriaValue = {
                    id: data.additional.uid,
                    text: data.additional.value,
                };
            }
        };

        ctrl.goToBottom = function () {
            if ($element[0].getBoundingClientRect().bottom > document.documentElement.clientHeight) {
                const scrollTop = $(window)
                    .scrollTop();
                $(window)
                    .scrollTop(($element[0].getBoundingClientRect().bottom - document.documentElement.clientHeight)
                        + scrollTop + 20);
            }
        };

        ctrl.getSubCriteriaData = async function () {
            if (!_.isEmpty(ctrl.data?.subCriteria)) {
                return staticDataService.getStaticData(ctrl.data.subCriteria.lookupData, (data) => {
                    ctrl.dynamicSubCriteriaData = data;

                    if (data) {
                        ctrl.data.selected = (ctrl.data.selected || []).map((item) => {
                            const additionalId = _.get(item, 'additional.uid');
                            const currentAdditionalValue = _.get(item, 'additional.value');
                            const additionalValue = data.find(({ id }) => id === additionalId);

                            if (additionalValue && !currentAdditionalValue) {
                                return {
                                    ...item,
                                    additional: {
                                        ...item.additional,
                                        ...additionalValue,
                                    },
                                };
                            }

                            return item;
                        });
                    }
                });
            }

            return Promise.resolve();
        };

        ctrl.subCriteriaChosen = function (value, init) {
            if (init && ctrl.dynamicSubCriteriaData) {
                const defaultSubCriteria = _.find(ctrl.dynamicSubCriteriaData, { isDefault: true });
                if (defaultSubCriteria) {
                    ctrl.subCriteriaValue = defaultSubCriteria;
                } else {
                    ctrl.subCriteriaValue = value;
                }
                ctrl.showSubCriteria = false;
                return;
            }
            ctrl.subCriteriaValue = value;
            ctrl.showSubCriteria = false;
            if (ctrl.inputReadyOnly && !init) {
                if (ctrl.data.selected.length > 0) {
                    ctrl.filterValueChosen(ctrl.data.selected[0]);
                } else {
                    ctrl.filterValueChosen(ctrl.originalValue);
                }
            }
        };

        ctrl.closeDynamic = function () {
            ctrl.showAdd = false;
            ctrl.showDropDown = false;
        };

        ctrl.removeValue = function (index) {
            ctrl.data.selected.splice(index, 1);
            ctrl.requiredIndexes.splice(index, 1);
            ctrl.onChange();
        };

        ctrl.checkFieldsSelected = function () {
            for (const allDataItem of (ctrl.allData || [])) {
                if (allDataItem?.selected && allDataItem.selected.length > 0) {
                    return true;
                }
                if (allDataItem?.minSelected && allDataItem.minSelected.length > 0) {
                    return true;
                }
                if (allDataItem?.maxSelected && allDataItem.maxSelected.length > 0) {
                    return true;
                }
            }
            return false;
        };

        ctrl.filterChanged = function (click) {
            if (click == true && ctrl.dynamicFilteredData && ctrl.dynamicFilteredData.resultListLength > 0) {
                ctrl.showDropDown = true;
                return;
            }
            if (ctrl.dynamicGetDataDelay) {
                $timeout.cancel(ctrl.dynamicGetDataDelay);
                ctrl.showDropDown = false;
            }
            if (ctrl.filterValues && ctrl.filterValues.length > 1
                || ctrl.checkFieldsSelected()) {
                ctrl.dynamicGetDataDelay = $timeout(() => {
                    const selected = [];
                    for (const element of (ctrl.allData || [])) {
                        if (element.selected && element.selected.length > 0) {
                            selected.push({
                                field: element.field,
                                items: element.selected,
                            });
                        }
                        if (element.minSelected && element.minSelected.length > 0) {
                            selected.push({
                                field: element.minField,
                                items: element.minSelected,
                            });
                        }
                        if (element.maxSelected && element.maxSelected.length > 0) {
                            selected.push({
                                field: element.maxField,
                                items: element.maxSelected,
                            });
                        }
                    }

                    const requestBody = {
                        currentField: {
                            field: ctrl.data.field,
                            type: 'Text',
                            value: ctrl.filterValues,
                            matchType: 'contains',
                        },
                        searchCountries: [
                            {
                                code: 'US',
                            },
                        ],
                        maxItems: ctrl.filteredValuesCount,
                        searchLanguages: [
                            {
                                code: 'en-US',
                            },
                        ],
                        selected,
                    };
                    if (ctrl.data.type == 'dynamic') {
                        dynamicDataService.getFilteredValues(requestBody)
                            .then((response) => {
                                ctrl.focusedOn = -1;
                                const { result: dynamicFilteredData = ctrl.dynamicFilteredData } = response || {};
                                ctrl.dynamicFilteredData = dynamicFilteredData;
                                if (ctrl.showAdd == true) {
                                    ctrl.showDropDown = true;
                                }
                                $timeout(() => {
                                    ctrl.goToBottom();
                                }, 200);
                            })
                            .catch((error) => Logger.error(error));
                    } else {
                        dynamicDataService.getFilteredSemiValues(requestBody)
                            .then((response) => {
                                ctrl.focusedOn = -1;
                                ctrl.dynamicFilteredData = response.result.results;
                                if (ctrl.showAdd == true) {
                                    ctrl.showDropDown = true;
                                }
                                $timeout(() => {
                                    ctrl.goToBottom();
                                }, 200);
                            })
                            .catch((error) => Logger.error(error));
                    }
                }, ctrl.filteredValuesDynamicDelay, false);
            }
        };

        ctrl.checkIfEnterKeyWasPressed = function (event) {
            const keyCode = event.which || event.keyCode;
            if (keyCode === 13) {
                if (ctrl.dynamicGetDataDelay) {
                    $timeout.cancel(ctrl.dynamicGetDataDelay);
                    ctrl.showDropDown = false;
                }

                if (!_.isEmpty(ctrl.filterValues)) {
                    if (!_.isEmpty(ctrl.multiValueSeparator)) {
                        _.chain(ctrl.filterValues)
                            .split(ctrl.multiValueSeparator)
                            .map(_.trim)
                            .filter(Boolean)
                            .map((text) => ctrl.filterValueChosen({ text }))
                            .value();
                    } else {
                        ctrl.filterValueChosen({ text: ctrl.filterValues });
                    }
                }
            }
        };
        ctrl.init();
    }

    setRequiredSubCriteria(idx, value) {
        this.mandatoryPopUpView = -1;
        this.data.selected[idx].required = value.required;

        const index = _.findIndex(this.mandatoryValues, { value: this.data.selected[idx].required });
        if (this.requiredIndexes.length === 0) {
            if (index >= 0) {
                const items = this.data.selected;
                for (let i = 0; i < items.length; i++) {
                    const importantIdx = _.findIndex(
                        this.mandatoryValues,
                        { value: this.data.selected[i].required },
                    );

                    this.requiredIndexes.push({
                        requiredValue: importantIdx,
                    });
                }

                this.requiredIndexes[idx].requiredValue = index;
            } else {
                this.requiredIndexes.push({
                    requiredValue: 0,
                });
            }
        } else if (index >= 0) {
            if (this.requiredIndexes[idx]) {
                this.requiredIndexes[idx].requiredValue = index;
            } else {
                this.requiredIndexes.push({
                    requiredValue: index,
                });
            }
        } else if (this.requiredIndexes[idx]) {
            this.requiredIndexes[idx].requiredValue = 0;
        } else {
            this.requiredIndexes.push({
                requiredValue: index,
            });
        }
        const subCriterita = _.find(this.dynamicSubCriteriaData, { text: value.additional });
        if (subCriterita) {
            this.subCriteriaValue = subCriterita;
            this.data.selected[idx].additional = {
                uid: this.subCriteriaValue.id,
                value: this.subCriteriaValue.text,
            };
            delete this.data.selected[idx].status;
        }
    }

    async initData() {
        this.showAdd = false;
        this.showDropDown = false;
        this.showSubCriteria = false;
        this.requiredIndexes = [];

        for (const selectedElement of (this.data?.selected || [])) {
            if (selectedElement.required === true) {
                selectedElement.required = 'mandatory';
            } else if (!selectedElement.required) {
                selectedElement.required = 'optional';
            } else if (selectedElement.required === 0 || selectedElement.required === false) {
                selectedElement.required = 'optional';
            }

            const index = _.findIndex(this.mandatoryValues, { value: selectedElement.required });

            if (index >= 0) {
                this.requiredIndexes.push({
                    requiredValue: index,
                });
            } else {
                this.requiredIndexes.push({
                    requiredValue: 0,
                });
            }
        }
        if (this.createJob && this.data.title === 'LOCATION') {
            this.inputReadyOnly = true;
            this.originalValue = angular.copy(this.data.selected[0]);
        }

        await this.getSubCriteriaData();

        if (this.lastSearch && this.lastSearch.field === this.data.field && this.data.multiple) {
            this.showAdd = true;
            this.filterValues = this.lastSearch.value;

            if (this.lastSearch.subCriteria) {
                this.subCriteriaChosen(this.lastSearch.subCriteria);
            }
        }

        this.hasPreferred = preferredPrioritySupportCriterias.includes(this.data?.field);
    }

    filterValueChosen(value) {
        if (this.data?.multiple === false && this.data?.selected.length === 1) {
            if (value.id) {
                this.data.selected[0].uid = value.id.toString();
            } else {
                delete this.data.selected[0].uid;
            }
            if (this.data.subCriteria !== null && this.subCriteriaValue) {
                this.data.selected[0].additional = {
                    uid: this.subCriteriaValue.id,
                    value: this.subCriteriaValue.text,
                };
            }
            const isSameText = value.text && (this.data?.selected[0].text === value.text);

            if (value.text) {
                this.data.selected[0].text = value.text;
            } else if (value.value) {
                this.data.selected[0].value = value.value;
            }

            if (this.data?.field !== 'locations') {
                const havePickedItem = this.data.selected[0].value && this.data.selected[0].text;
                if (havePickedItem) {
                    this.data.selected[0].value = this.data.selected[0].text;
                }
            } else {
                const { text } = this.data.selected[0];
                const locationValue = value.value;
                if (!text) {
                    this.data.selected[0] = locationValue;
                }
                const valueIsCoords = this.utils.isLocationString(locationValue);
                if (valueIsCoords) {
                    this.data.selected[0].value = locationValue;
                } else if (!isSameText) {
                    this.data.selected[0].value = '';
                }
            }

            this.showDropDown = false;
            this.showAdd = false;
            this.filterValues = '';
        } else {
            if (value.id) {
                value.id = value.id.toString();
            }
            const selected = {
                uid: value.id || '0',
                value: value.value || value.text,
                text: value.text,
                required: 'optional',
            };

            if (value.isNationwide) {
                const subCriteria = _.find(this.dynamicSubCriteriaData, { id: value.radius });
                if (subCriteria) {
                    selected.additional = {
                        uid: subCriteria.id,
                        value: subCriteria.text,
                    };
                }
            } else if (this.data?.subCriteria !== null && this.subCriteriaValue) {
                selected.additional = {
                    uid: this.subCriteriaValue.id,
                    value: this.subCriteriaValue.text,
                };
            }

            if (!_.find(this.data?.selected, { value: selected.value })) {
                (this.onBeforeValueAdded() || (() => {}))(selected);
                const newValue = [...this.data?.selected, selected].filter((i) => !_.isUndefined(i));
                _.set(this, 'data.selected', newValue);
            }

            if (this.data.multiple === true && (this.data.selected.length > 1 || this.doNotHideDropDownAfterSelect)) {
                this.filterChanged();
            } else {
                this.showDropDown = false;
                this.showAdd = false;
                this.filterValues = '';
            }
        }

        this.searchCacheService.saveLastSearchField(this.data.field, this.filterValues, this.subCriteriaValue);
        this.onChange();
    }

    setPopupView(value) {
        this.mandatoryPopUpView = value;
    }
}

export const DynamicCriteriaComponentConfiguration = {
    bindings: {
        data: '=',
        lastSearch: '=',
        allData: '=',
        disable: '=',
        createJob: '=',
        doNotHideDropDownAfterSelect: '=',
        onChange: '&',
        onBeforeValueAdded: '&',
        multiValueSeparator: '=',
    },
    controller: DynamicCriteriaComponent,
    template,
    controllerAs: 'dynamicCriteriaCtrl',
};

angular
    .module('TALENYA-FE')
    .component('dynamicCriteriaComponent', DynamicCriteriaComponentConfiguration);
